import React from 'react'
import container from './container'

const ModalVisibleHandler = props => {
    const { children, handleClick } = props
    return React.cloneElement(children, { onClick: handleClick })
}

export default container(ModalVisibleHandler)
